'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countHouses = exports.listDataXLS = undefined;

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listDataXLS = exports.listDataXLS = function listDataXLS(mapID, featureID) {
  return (0, _callApi2.default)('POST', '/integrations/cole/data-xls', { mapID: mapID, featureID: featureID }, 'application/json');
};
var countHouses = exports.countHouses = function countHouses(polygon) {
  return (0, _callApi2.default)('POST', '/integrations/cole/count', { polygon: polygon }, 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/data.js
// module id = 729
// module chunks = 0